import { render } from "./ManageMember.vue?vue&type=template&id=54fb8f8f&scoped=true"
import script from "./ManageMember.vue?vue&type=script&lang=js"
export * from "./ManageMember.vue?vue&type=script&lang=js"

import "./ManageMember.vue?vue&type=style&index=0&id=54fb8f8f&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fb8f8f"]])

export default __exports__